// src/redux/actions/wishlistActions.js
import {
  AddToWishlist,
  ViewWishlist,
  DeleteWishlist,
} from "../../Services/MainServices";
import { toast } from "react-toastify";

// Action Types
export const WISHLIST_REQUEST = "WISHLIST_REQUEST";
export const WISHLIST_SUCCESS = "WISHLIST_SUCCESS";
export const WISHLIST_FAILURE = "WISHLIST_FAILURE";

export const ADD_WISHLIST_SUCCESS = "ADD_WISHLIST_SUCCESS";
export const DELETE_WISHLIST_SUCCESS = "DELETE_WISHLIST_SUCCESS";

// Helpers
const isAuthenticated = () => !!localStorage.getItem("access_token");

// Fetch Wishlist
export const fetchWishlist = () => async (dispatch, getState) => {
  if (!isAuthenticated()) return;

  dispatch({ type: WISHLIST_REQUEST });
  try {
    // const user_id = getState().auth?.user?.user_id;
    // console.log("Fetching wishlist for user_id:", user_id);
    const resp = await ViewWishlist(); // user_id is a number
    const wishlistItems = resp?.data?.results?.data || [];

    // console.log("Wishlist Items:", wishlistItems);
    dispatch({ type: WISHLIST_SUCCESS, payload: wishlistItems });
  } catch (err) {
    dispatch({
      type: WISHLIST_FAILURE,
      payload: err?.response?.data?.message || err.message,
    });
    // toast.error("Failed to fetch wishlist");
  }
};

// Add to Wishlist
export const addToWishlist = (payload) => async (dispatch) => {
  if (!isAuthenticated()) {
    toast.warn("Please login to use wishlist");
    return;
  }

  dispatch({ type: WISHLIST_REQUEST });
  try {
    const resp = await AddToWishlist(payload);
    const item = resp?.data?.data;
    if (
      (resp.status === 200 || resp.status === 201) &&
      resp.data.status === "success"
    ) {
      dispatch({ type: ADD_WISHLIST_SUCCESS, payload: item });
      toast.success("Added to wishlist");
    } else {
      throw new Error(resp?.data?.message || "Add to wishlist failed");
    }
  } catch (err) {
    dispatch({
      type: WISHLIST_FAILURE,
      payload: err?.response?.data?.message || err.message,
    });
    // toast.error("Failed to add to wishlist");
  }
};

// Delete from Wishlist
export const deleteWishlistItem = (id) => async (dispatch) => {
  if (!isAuthenticated()) {
    toast.warn("Please login to modify wishlist");
    return;
  }

  dispatch({ type: WISHLIST_REQUEST });
  try {
    await DeleteWishlist(id);
    dispatch({ type: DELETE_WISHLIST_SUCCESS, payload: id });
    toast.info("Removed from wishlist");
  } catch (err) {
    dispatch({
      type: WISHLIST_FAILURE,
      payload: err?.response?.data?.message || err.message,
    });
    // toast.error("Failed to remove from wishlist");
  }
};

// Toggle Wishlist Item
export const toggleWishlistItem = (productId) => (dispatch, getState) => {
  const wishlist = getState().wishlist.items || [];
  const item = wishlist.find(
    (item) => (item.product?.pro_id || item.pro_id) === productId
  );

  if (item) {
    // Remove using the wishlist item's id, not the product id!
    dispatch(removeFromWishlist(item.id));
  } else {
    dispatch(addToWishlist(productId));
  }
};

// Remove from Wishlist (helper)
export const removeFromWishlist = (id) => async (dispatch) => {
  dispatch({ type: WISHLIST_REQUEST });
  try {
    await DeleteWishlist(id);
    dispatch({ type: DELETE_WISHLIST_SUCCESS, payload: id });
    toast.info("Removed from wishlist");
  } catch (err) {
    dispatch({
      type: WISHLIST_FAILURE,
      payload: err?.response?.data?.message || err.message,
    });
    // toast.error("Failed to remove from wishlist");
  }
};
